import { render, staticRenderFns } from "./Coaches.vue?vue&type=template&id=9e04736a"
import script from "./Coaches.vue?vue&type=script&lang=js"
export * from "./Coaches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports